import type { FC, ReactNode } from 'react';

import tw, { styled } from 'twin.macro';
import { Progress, CircularProgress, CircularProgressLabel } from '@chakra-ui/react';

import formatNumber from '@/utils/formatNumber';

export interface SalesProgressProp {
  children: ReactNode;
  colorScheme: string;
  sold: number;
  max: number;
  preOrdered?: number;
}

const OverrideCircularProgress = styled(CircularProgress)`
  .chakra-progress__track {
    stroke: #2d323b !important;
  }
`;

export function SaleProgressCircle({ children, colorScheme, sold, max, preOrdered }: SalesProgressProp) {
  if (preOrdered === undefined) {
    return (
      <div tw="flex flex-col gap-2.5 items-center w-16 h-20">
        <OverrideCircularProgress size="12" value={(sold / max) * 100} thickness="6px" color={`${colorScheme}.500`}>
          <CircularProgressLabel>
            <div tw="flex flex-row justify-center items-center text-white">{children}</div>
          </CircularProgressLabel>
        </OverrideCircularProgress>
        <div tw="text-sm text-grey-300">
          {formatNumber(sold)}/{formatNumber(max)}
        </div>
      </div>
    );
  }
  return (
    <div tw="flex flex-col gap-2.5 items-center w-16 h-20">
      <OverrideCircularProgress value={preOrdered} max={max} thickness="6px" color={`${colorScheme}.500`} size="16">
        <CircularProgressLabel>
          <OverrideCircularProgress size="12" value={(sold / max) * 100} thickness="6px" color={`${colorScheme}.500`}>
            <CircularProgressLabel>
              <div tw="flex flex-row justify-center items-center text-white">{children}</div>
            </CircularProgressLabel>
          </OverrideCircularProgress>
        </CircularProgressLabel>
      </OverrideCircularProgress>
      <div tw="text-sm text-grey-300">
        {formatNumber(sold)}/{formatNumber(max)}
      </div>
    </div>
  );
}

export function SaleProgress({ children, colorScheme, sold, max }: SalesProgressProp) {
  return (
    <div tw="flex flex-row gap-2.5 items-center">
      {children}
      <Progress size="sm" colorScheme={colorScheme} value={sold} max={max} tw="w-full" />
      <div tw="text-sm text-grey-300">
        {sold}/{max}
      </div>
    </div>
  );
}
